/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Tabs, Row, Col, Upload, Modal } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './contentDetail.css';
import { useSelector } from 'react-redux';

import 'react-quill/dist/quill.snow.css';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/styles';
import { InputAdornment } from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import CButton from '../../component/Button';
import { uploadBanner } from '../../services/napi';
import FieldElement from '../../component/FieldElement';
import textIcon from '../../asset/text.svg';
import richTextIcon from '../../asset/richtext.svg';
import mediaIcon from '../../asset/media.svg';
import dateIcon from '../../component/DatePicker/Date.svg';
import CReactQuill from '../../component/Quill/ReactQuill';
import { CStandardInput } from '../../component/Input';
import CustomDatePicker from '../../component/DatePicker';

const { TabPane } = Tabs;
const useStyles = makeStyles({
  root: {
    ' & .MuiInputBase-root': {
      background: '#F0F4FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px 40px 0px 35px',
      padding: '14px 16px'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    }
  }
});

const datePickerStyle = {
  display: 'flex',
  justifyContent: 'start',
  padding: '0 35px',
  width: '100%'
};

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const TextElement = ({ value, characterLimit, onChange = () => {} }) => {
  const classes = useStyles();
  const [inputTextLength, setInputTextLength] = useState(value.length);

  return (
    <CStandardInput
      adornment={
        characterLimit ? (
          <InputAdornment
            position="end"
            style={
              characterLimit - inputTextLength === 0
                ? { color: 'red' }
                : { color: 'rgba(0, 0, 0, 0.85)' }
            }
          >
            {characterLimit - inputTextLength}
          </InputAdornment>
        ) : null
      }
      disableUnderline
      formclasses={{ root: classes.root }}
      inputProps={{
        maxLength: characterLimit
      }}
      onChange={(e) => {
        onChange(e.target.value);
        setInputTextLength(e.target.value.length);
      }}
      value={value}
      width="true"
    />
  );
};

const DateElement = ({ value, onChange = () => {} }) => {
  return (
    <div style={datePickerStyle}>
      <CustomDatePicker onChange={onChange} value={value} />
    </div>
  );
};

const ChipsTextElement = ({ value, onChange = () => {} }) => {
  const [chips, setChips] = useState(value || []);

  const handleAddChip = (chip) => {
    setChips((prev) => {
      const updatedChips = [...prev, chip];
      onChange(updatedChips);
      return updatedChips;
    });
  };
  const handleDeleteChip = (chip) => {
    setChips(() => {
      const filteredChips = chips.filter((item) => item !== chip);
      onChange(filteredChips);
      return filteredChips;
    });
  };

  return (
    <ChipInput
      newChipKeys={['Enter', ' ', 'Tab']}
      onAdd={(chip) => handleAddChip(chip)}
      onDelete={(chip) => handleDeleteChip(chip)}
      placeholder="Enter tags"
      style={{ width: '95%' }}
      value={chips}
    />
  );
};

const RichTextElement = ({ value, onChange = () => {} }) => {
  return (
    <>
      <CReactQuill
        onChange={(content) => {
          onChange(content);
        }}
        style={{
          height: '300px'
        }}
        theme="snow"
        value={value}
      />
    </>
  );
};

const ObjectElement = ({ field_addition, value, onChange = () => {} }) => {
  const classes = useStyles();
  const keys = Object.keys(field_addition);

  return (
    <div>
      {keys.map((key, index) => {
        return (
          <div key={index} style={{ marginBottom: '10px', textAlign: 'left' }}>
            <h4 style={{ fontSize: '12px', marginLeft: '38px' }}>{key}</h4>
            <CStandardInput
              disableUnderline
              formclasses={{ root: classes.root }}
              onChange={(e) => {
                onChange({
                  ...value,
                  [key]: e.target.value
                });
              }}
              value={value[key]}
              width="true"
            />
          </div>
        );
      })}
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const SelectElement = ({ field_addition, value, onChange = () => {} }) => {
  const classes = useStyles();
  const keys = Object.keys(field_addition);

  return (
    <div>
      {keys.map((index, key) => {
        return (
          <div key={key} style={{ marginBottom: '10px', textAlign: 'left' }}>
            <h4 style={{ fontSize: '12px', marginLeft: '38px' }}>{key}</h4>
            <CStandardInput
              disableUnderline
              formclasses={{ root: classes.root }}
              onChange={(e) => {
                onChange({
                  ...value,
                  [key]: e.target.value
                });
              }}
              value={value[key]}
              width="true"
            />
          </div>
        );
      })}
    </div>
  );
};

const MediaElement = ({ index, value, ratio, onChange = () => {} }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [uploaded, setUploaded] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [uploadedSize, setUploadedSize] = useState(null);
  // const [uploadedSize, setUploadedSize] = useState(null);
  // const [uploadedRatio, setUploadedRatio] = useState(0);

  const [ratioWindow, setRatioWindow] = useState(false);

  const [fileList, setFileList] = useState([]);
  // const [compressedFile, setCompressedFile] = useState(null);

  useEffect(() => {
    if (value) {
      setFileList([
        {
          name: 'Preview',
          status: 'done',
          uid: index,
          url: value || ''
        }
      ]);
    }
  }, [value, index]);

  const projectId = useSelector(({ project }) => project.currentProject._id);

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };

  const handleChange = ({ fileList }) => {
    if (fileList.length) {
      setUploadedSize(formatBytes(fileList[0].size));
      // setUploadedSize(formatBytes(fileList[0]['size']));
    }

    setFileList(fileList);

    if (!fileList.length) {
      onChange('');
    }
    setFileList([]);
  };

  const ratioLimiter = (file) => {
    // let result;
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.addEventListener('load', (event) => {
        const _loadedImageUrl = event.target.result;
        const image = document.createElement('img');
        image.src = _loadedImageUrl;
        image.addEventListener('load', () => {
          const { width, height } = image;

          resolve((width / height).toFixed(2));
        });
      });
    });
  };

  const uploadRequest = async (data) => {
    const formData = new FormData();
    formData.append('file', data.file);

    const res = await uploadBanner(formData, projectId);

    onChange(res.data.file.url);

    data.onSuccess();
  };

  const customRequest = async (data) => {
    const uploadedRatio = await ratioLimiter(data.file);

    if (ratio) {
      const { ratioWidth, ratioHeight } = ratio;
      const standardRatio = (ratioWidth / ratioHeight).toFixed(2);

      if (uploadedRatio === standardRatio) {
        uploadRequest(data);
      } else {
        setUploaded(data);
        setRatioWindow(true);
      }
    } else {
      uploadRequest(data);
    }
  };

  function formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        paddingLeft: '35px'
      }}
    >
      <Upload
        customRequest={customRequest}
        fileList={fileList}
        listType="picture-card"
        onChange={handleChange}
        onPreview={handlePreview}
      >
        {uploadButton}
      </Upload>

      <Modal
        centered
        footer={null}
        onCancel={() => setRatioWindow(false)}
        title="Aspect Ratio does not match"
        visible={ratioWindow}
      >
        <h1 style={{ textAlign: 'center' }}>Delete uploaded image or Add?</h1>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <CButton
            onClick={() => {
              // setUploadedSize(0);
              setRatioWindow(false);
            }}
            size="large"
            type="secondary"
          >
            Delete
          </CButton>
          <CButton
            onClick={() => {
              uploadRequest(uploaded);
              setRatioWindow(false);
            }}
            size="large"
            type="primary"
          >
            Add
          </CButton>
        </div>
      </Modal>

      <Modal footer={null} onCancel={handleCancel} title={previewTitle} visible={previewVisible}>
        <img alt="example" src={previewImage} style={{ width: '100%' }} />
      </Modal>
    </div>
  );
};

const CheckBoxElement = ({ label, value, onChange = () => {} }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value}
          onChange={(event) => {
            onChange(event.target.checked);
          }}
          // indeterminate
        />
      }
      label={label}
    />
  );
};

const ContentDetailForm = (props) => {
  const { content, lang, onGenericChange } = props;
  const activeLanguages = useSelector(({ language }) => language.activeLanguages);

  const fields = Object.keys(content?.customType?.template || {}).map((key, index) => {
    const item = content.customType.template[key];
    item.name = key;

    return {
      field: item,
      index,
      key: index
    };
  });

  const keys = [];
  Object.keys(content.data).forEach((key) => {
    keys.push(key);
  });

  if (content.data.length !== activeLanguages.length) {
    const filterLanguages = activeLanguages.filter(
      (language) => keys.filter((key) => language.key === key).length === 0
    );
    let filterLanguagesKay;

    if (filterLanguages.length) {
      filterLanguagesKay = filterLanguages[0].key;
    }

    const emptyField = { ...content.data.en };

    Object.keys(emptyField).forEach((key) => {
      emptyField[key] = '';
    });
    content.data = { ...content.data, [filterLanguagesKay]: emptyField };
  }

  const data = content.data[lang];

  return (
    <Row>
      <Col span={24}>
        {fields.map(({ field }, index) => {
          const { field_type, label, name } = field;

          switch (field_type) {
            case 'text':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={textIcon}
                  lang={lang}
                  name={name}
                  title={label}
                  type={field_type}
                >
                  <TextElement
                    characterLimit={
                      field.field_addition ? field.field_addition.characterLimit : null
                    }
                    lang={lang}
                    onChange={onGenericChange(name, lang)}
                    title={label}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'list':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={textIcon}
                  lang={lang}
                  name={name}
                  title={label}
                  type={field_type}
                >
                  <ChipsTextElement
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || []}
                  />
                </FieldElement>
              );
            case 'tinymce':
              return (
                <FieldElement
                  key={index}
                  align="top"
                  alt="rich text icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={richTextIcon}
                  height="340px"
                  // justify="start"
                  margin="0px"
                  title={label}
                >
                  <RichTextElement
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'file':
              return (
                <FieldElement
                  key={index}
                  alt="media icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={mediaIcon}
                  title={label}
                >
                  <MediaElement
                    index={index}
                    onChange={onGenericChange(name, lang)}
                    ratio={field.field_addition}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'date':
              return (
                <FieldElement
                  key={index}
                  alt="date icon"
                  edition={field.field_addition ? field.field_addition : {}}
                  fieldIcon={dateIcon}
                  title={label}
                  type={field_type}
                >
                  <DateElement
                    index={index}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'checkbox':
              return (
                <FieldElement key={index} title={label}>
                  <CheckBoxElement
                    index={index}
                    label={label}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'complex list':
              return (
                <FieldElement
                  key={index}
                  alt="text icon"
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <ObjectElement
                    field_addition={field.field_addition ? field.field_addition : {}}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            case 'Select':
              return (
                <FieldElement
                  key={index}
                  alt="text icon"
                  fieldIcon={richTextIcon}
                  title={label}
                  type={field_type}
                >
                  <ObjectElement
                    field_addition={field.field_addition ? field.field_addition : {}}
                    onChange={onGenericChange(name, lang)}
                    value={data[name] || ''}
                  />
                </FieldElement>
              );
            default:
              return <p key={index}>{field_type}</p>;
          }
        })}
      </Col>
    </Row>
  );
};

const ContentDetailBody = ({ contentDraft, setContentDraft, isEditable }) => {
  const onGenericChange = (key, lang) => {
    return (value) => {
      setContentDraft({
        ...contentDraft,
        data: {
          ...contentDraft.data,
          [lang]: {
            ...contentDraft.data[lang],
            [key]: value
          }
        }
      });
    };
  };

  const activeLanguages = useSelector(({ language }) => language.activeLanguages);

  return (
    <div
      style={{
        background: 'white',
        margin: '0px',
        paddingBottom: '64px',
        width: '50%'
      }}
    >
      <div
        style={{
          background: '#F0F4FF',
          borderRadius: '12px',
          margin: '20px 35px',
          padding: '14px 16px'
        }}
      >
        {isEditable ? 'Final Content' : `Review Request from `}
        {!isEditable ? <strong>{contentDraft.author.email}</strong> : null}
      </div>
      <Tabs defaultActiveKey="0">
        {activeLanguages.map(({ name, key }, index) => (
          <TabPane key={index} tab={<div className="custom-tabs">{name}</div>}>
            <ContentDetailForm
              content={contentDraft}
              lang={key}
              onGenericChange={onGenericChange}
            />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default ContentDetailBody;
